interface BasePathProps {
  protocol: string;
  hostname: string;
}

export const useBasePath = (): BasePathProps => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  return { protocol, hostname };
};
